import { render } from "./SkySwitch.vue?vue&type=template&id=0a343587&scoped=true"
import script from "./SkySwitch.vue?vue&type=script&lang=js"
export * from "./SkySwitch.vue?vue&type=script&lang=js"

import "./SkySwitch.vue?vue&type=style&index=0&id=0a343587&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a343587"]])

export default __exports__